<div class="preview"
  [attr.data-fade]="block.previewSettings?.fade"
  [attr.data-horizontal-align]="block.previewSettings?.horizontalAlign"
  [attr.data-vertical-align]="block.previewSettings?.verticalAlign"
  >
    <div class="overlay"></div>
    @if (block.preview) {
      <tyt-content-block [block]="previewOf(block)"></tyt-content-block>
    }
</div>